import api from './client'

export interface AnchorRepeat {
  axis?: 'x' | 'y'
  count?: number
  step?: number
  first_offset?: number
}

export interface AnchorDef {
  x: number
  y: number
  anchor?: string
  scale?: number
  repeat?: AnchorRepeat
  _comment?: string
}

export interface StyleMaster {
  canvas: { width: number; height: number }
  base: { file: string; _comment?: string }
  anchors: Record<string, AnchorDef>
  elements: Record<string, Record<string, string>>
  fabric_apply?: string[]
  fabric_swatches?: Record<string, string>
  fabric_swatch_picker?: {
    fabric_overrides?: Record<string, string>
    by_color?: Record<string, string>
    by_fabric?: Record<string, string>
  }
  default_buttons?: Record<string, string>
  [key: string]: unknown
}

export async function loadStyleMaster(masterId: string): Promise<StyleMaster> {
  const res = await api.get(`/style-master/${masterId}`)
  return res.data as StyleMaster
}

export async function saveStyleMaster(
  masterId: string,
  master: StyleMaster,
): Promise<void> {
  await api.put(`/style-master/${masterId}`, master)
}

export async function previewStyleMaster(
  masterId: string,
  color: string | null,
  attrs: Record<string, string>,
  master?: StyleMaster,
): Promise<{ imageUrl: string }> {
  const body: Record<string, unknown> = { color, attrs }
  if (master) body.master = master
  const res = await api.post(`/style-master/${masterId}/preview`, body)
  return res.data as { imageUrl: string }
}

export interface MasterSummary {
  id: string
  canvas: { width?: number; height?: number }
  elementKeys: string[]
  anchorCount: number
}

export async function listStyleMasters(): Promise<MasterSummary[]> {
  const res = await api.get('/style-master')
  return (res.data?.masters || []) as MasterSummary[]
}

export async function bootstrapStyleMaster(
  masterId: string,
  templateId = 'shirt_master',
  force = false,
): Promise<StyleMaster> {
  const res = await api.post(`/style-master/${masterId}/bootstrap`, {
    templateId,
    force,
  })
  return res.data as StyleMaster
}
